import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import SalesIndex from './join';
import track from 'utils/track';

export default function (props) {
  const {
    phases: {
      sales: salesSchedule = {
        phase: 'during',
        salesEnd: ''
      }
    }
  } = usePhaseState();

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'C-TT2',
      sku: 'C-TT2',
      name: 'Tackling Type 2',
      variant: salesSchedule.phase != 'during' ? 'tt2' : 'tt2-special',
      value: salesSchedule.phase != 'during' ? 497 : 297,
      currency: 'usd'
    });
  }, [salesSchedule.phase]);

  const salesTimeOverride = new Date(salesSchedule.salesEnd).getTime();

  return (
    <SalesIndex
      ctaOverride={salesSchedule.phase != 'during' ? 'sales497' : 'sales297'}
      videoUrlOverride={
        salesSchedule.phase != 'during'
          ? 'https://www.youtube.com/watch?v=bpOGfDYeDho'
          : 'https://www.youtube.com/watch?v=h5G2J45mo-o'
      }
      timerOverride={salesTimeOverride}
    />
  );
}
